import React, { useState, useEffect } from "react";
import { Row, Col, FormGroup, Input, Button } from "reactstrap";
import { URL } from "../../api";
import axiosInstance from "../../Request";
import { useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import getPrivilegeList from "../../PrivilegeList";
const EMPLOYMENT_TYPES = {
  1: "Salaried",
  2: "Self-Employed",
  3: "Corporation",
  4: "Proprietorship",
  5: "Partnership",
};

const ProfessionalDetails = ({ customerDetails, disableEdit }) => {
  const { cid,lid } = useParams();
const privilegeList = getPrivilegeList();
// Payment view (/payment/...) shows the new trimmed professional detail; the regular customer view
// (/customer/...) shows the full old professional view with all fields.
const isPayment = typeof window !== "undefined" && window.location.pathname.includes("/payment/");
  const defaultValues = {
    companyName: "-NA-",
    designation: "-NA-",
    ownerName: "-NA-",
    professionalEmail: "-NA-",
    salary: "-NA-",
    salaryDate: "-NA-",
    annualIncome: "-NA-",
    companyType: "-NA-",
    industry: "-NA-",
    gst: "-NA-",
    employmentType: "-NA-",
    ownership: "-NA-",
  };

  const [editableDetails, setEditableDetails] = useState(defaultValues);
  const [initialDetails, setInitialDetails] = useState(defaultValues);
  const [isEditable, setIsEditable] = useState(false);

  useEffect(() => {
    if (customerDetails?.professionalDetail) {
      const details = customerDetails.professionalDetail;
      const mappedDetails = {
        companyName: details.companyName || "-NA-",
        designation: details.designation || "-NA-",
        ownerName: details.ownerName || "-NA-",
        professionalEmail: details.professionalEmail || "-NA-",
        salary: details.salary || "-NA-",
        salaryDate: details.salaryDate || "-NA-",
        annualIncome: details.annualIncome || "-NA-",
        companyType: details.companyType || "-NA-",
        industry: details.industry || "-NA-",
        gst: details.gst || "-NA-",
        employmentType: details.employmentType || "-NA-",
        ownership: details.ownership || "-NA-",
      };
      setEditableDetails(mappedDetails);
      setInitialDetails(mappedDetails);
    }
  }, [customerDetails]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditableDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleEditClick = () => setIsEditable(true);

  const handleCancelClick = () => {
    setEditableDetails({ ...initialDetails });
    setIsEditable(false);
  };

  const handleUpdateClick = () => {
    const modifiedFields = {};
    Object.keys(editableDetails).forEach((key) => {
      if (editableDetails[key] !== initialDetails[key]) {
        modifiedFields[key] = editableDetails[key];
      }
    });

    if (Object.keys(modifiedFields).length === 0) {
      toast.info("No changes made.");
      setIsEditable(false);
      return;
    }

    updateProfessionalDetails(modifiedFields);
    setIsEditable(false);
  };

  const updateProfessionalDetails = async (modifiedFields) => {
    const fieldMapping = {
      companyName: "company_name",
      designation: "designation",
      ownerName: "owner_name",
      professionalEmail: "professional_email",
      salary: "salary",
      salaryDate: "salary_date",
      annualIncome: "annual_income",
      companyType: "company_type",
      industry: "industry",
      gst: "gst",
      employmentType: "employment_type",
      ownership: "ownership",
    };

    const payload = { customer_id: cid , lead_id: lid };

    Object.entries(modifiedFields).forEach(([key, value]) => {
      const mappedKey = fieldMapping[key];
      if (["salary", "salaryDate", "annualIncome"].includes(key)) {
        payload[mappedKey] = Number(value);
      } else {
        payload[mappedKey] = value;
      }
    });

    try {
  const response = await axiosInstance.post(URL.UPDATE_PROFESSIONAL, payload);
  const result = response.data;

  toast.success(result.message || "Updated successfully");
  setInitialDetails(editableDetails); // update snapshot
} catch (error) {
  const errorMsg = error?.response?.data?.message || "Update failed";
  toast.error(errorMsg);
}
  };

  return (
    <div>
      <ToastContainer />
      <h6 className="heading-small text-muted mb-4">Professional Info</h6>
      <div className="pl-lg-4">
        <Row>
          <Col md="6">
            <FormGroup>
              <label className="form-control-label" htmlFor="companyName">Company Name</label>
              <Input
                className="form-control-alternative"
                id="companyName"
                name="companyName"
                type="text"
                value={editableDetails.companyName}
                onChange={handleInputChange}
                disabled={!isEditable}
              />
            </FormGroup>
          </Col>
          {!isPayment && (
          <Col md="6">
            <FormGroup>
              <label className="form-control-label" htmlFor="designation">Designation</label>
              <Input
                className="form-control-alternative"
                id="designation"
                name="designation"
                type="text"
                value={editableDetails.designation}
                onChange={handleInputChange}
                disabled={!isEditable}
              />
            </FormGroup>
          </Col>
          )}
        </Row>

        <Row>
          {!isPayment && (
          <Col md="6">
            <FormGroup>
              <label className="form-control-label" htmlFor="employmentType">Employment Type</label>
              <select
                className="form-control-alternative form-control"
                id="employmentType"
                name="employmentType"
                value={editableDetails.employmentType}
                onChange={handleInputChange}
                disabled={!isEditable}
              >
                <option value="">--Select--</option>
                {Object.entries(EMPLOYMENT_TYPES).map(([id, label]) => (
                  <option key={id} value={id}>{label}</option>
                ))}
              </select>
            </FormGroup>
          </Col>
          )}
          {!isPayment && (
          <Col md="6">
            <FormGroup>
              <label className="form-control-label" htmlFor="professionalEmail">Professional Email</label>
              <Input
                className="form-control-alternative"
                id="professionalEmail"
                name="professionalEmail"
                type="email"
                value={
                  privilegeList.professionalDetailsContactInfoShow
                    ? editableDetails.professionalEmail
                    : editableDetails.professionalEmail
                      ? "*******" + editableDetails.professionalEmail.slice(-10)
                      : ""
                }
                onChange={handleInputChange}
                disabled={true}
              />
            </FormGroup>
          </Col>
          )}
        </Row>

        <Row>
          {!isPayment && (
          <Col md="6">
            <FormGroup>
              <label className="form-control-label" htmlFor="salary">Salary</label>
              <Input
                className="form-control-alternative"
                id="salary"
                name="salary"
                type="text"
                value={
                  privilegeList.professionalDetailsIncomeInfoShow
                    ? editableDetails.salary
                    : editableDetails.salary
                      ? "******" + String(editableDetails.salary).slice(-2)
                      : ""
                }
                onChange={handleInputChange}
                disabled={true}
              />
            </FormGroup>
          </Col>
          )}
          {!isPayment && (
          <Col md="6">
            <FormGroup>
              <label className="form-control-label" htmlFor="salaryDate">Salary Date</label>
              <Input
                className="form-control-alternative"
                id="salaryDate"
                name="salaryDate"
                type="text"
                value={editableDetails.salaryDate}
                onChange={handleInputChange}
                disabled={!isEditable}
              />
            </FormGroup>
          </Col>
          )}
        </Row>

        <Row>
          <Col md="6">
            <FormGroup>
              <label className="form-control-label" htmlFor="annualIncome">Annual Income</label>
              <Input
                className="form-control-alternative"
                id="annualIncome"
                name="annualIncome"
                type="text"
                value={
                  privilegeList.professionalDetailsIncomeInfoShow
                    ? editableDetails.annualIncome
                    : editableDetails.annualIncome
                      ? "******" + String(editableDetails.annualIncome).slice(-2)
                      : ""
                }
                onChange={handleInputChange}
                disabled={true}
              />
            </FormGroup>
          </Col>
          {!isPayment && (
          <Col md="6">
            <FormGroup>
              <label className="form-control-label" htmlFor="companyType">Company Type</label>
              <Input
                className="form-control-alternative"
                id="companyType"
                name="companyType"
                type="text"
                value={editableDetails.companyType}
                onChange={handleInputChange}
                disabled={!isEditable}
              />
            </FormGroup>
          </Col>
          )}
        </Row>

        {!isPayment && (
        <>
        <Row>
          <Col md="6">
            <FormGroup>
              <label className="form-control-label" htmlFor="gst">GST</label>
              <Input
                className="form-control-alternative"
                id="gst"
                name="gst"
                type="text"
                value={editableDetails.gst}
                onChange={handleInputChange}
                disabled={!isEditable}
              />
            </FormGroup>
          </Col>
          <Col md="6">
          <FormGroup>
              <label className="form-control-label" htmlFor="ownerName">Owner Name</label>
              <Input
                className="form-control-alternative"
                id="ownerName"
                name="ownerName"
                type="text"
                value={editableDetails.ownerName}
                onChange={handleInputChange}
                disabled={!isEditable}
              />
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col md="6">
            <FormGroup>
              <label className="form-control-label" htmlFor="ownership">Ownership</label>
              <Input
                className="form-control-alternative"
                id="ownership"
                name="ownership"
                type="text"
                value={editableDetails.ownership}
                onChange={handleInputChange}
                disabled={!isEditable}
              />
            </FormGroup>
          </Col>
        </Row>
        </>
        )}

        {privilegeList?.professionalDetailsEdit &&  !disableEdit &&(
          <Row>
            <Col className="text-right" xs="12">
              {!isEditable ? (
                <Button color="primary" size="sm" onClick={handleEditClick}>Edit</Button>
              ) : (
                <>
                  <Button color="secondary" size="sm" onClick={handleCancelClick}>Cancel</Button>
                  <Button color="primary" size="sm" onClick={handleUpdateClick}>Update</Button>
                </>
              )}
            </Col>
          </Row>
        )}
      </div>
    </div>
  );
};

export default ProfessionalDetails;
